import {AddToCart} from './addToCart'

export default AddToCart
